// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadiusBottomrightOutlinedSvg from "@fishx/icons-svg/es/asn/PRadiusBottomrightOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadiusBottomrightOutlined = function PRadiusBottomrightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadiusBottomrightOutlinedSvg
  }));
};

PRadiusBottomrightOutlined.displayName = 'PRadiusBottomrightOutlined';
export default React.forwardRef(PRadiusBottomrightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadiusBottomrightOutlined.js
// module id = 3569
// module chunks = 0